import type { ReactElement, ReactNode } from 'react'

import { Container } from '@twistopayments/design-system/components/atoms/container'
import { Hidden } from '@twistopayments/design-system/components/atoms/hidden'
import { Layout } from '@twistopayments/design-system/components/atoms/layout'

import { useAdditionalData } from 'homepage/libs/context'

import { ArticlesSearchInput } from '../articles-search-input'

import * as styles from './category-layout.styles'

type Props = {
  breadcrumbs: ReactElement
  contentNavigation: ReactElement
  children: ReactNode
  rootCategoryId?: number
}

export const CategoryLayout = ({
  breadcrumbs,
  contentNavigation,
  children,
}: Props) => {
  const { staticTexts } = useAdditionalData()

  return (
    <main>
      <Layout grayBackground variant="screen">
        <Container fullHeight noPadding css={styles.container} size="wider">
          <div>
            <ArticlesSearchInput
              css={styles.searchInput}
              dropdownClassName={styles.dropdown}
              placeholder={
                staticTexts?.categoryLayoutSearchInputPlaceholder || ''
              }
            />
            <Hidden smDown>{contentNavigation}</Hidden>
          </div>
          <section css={styles.content}>
            <div css={styles.breadcrumb}>{breadcrumbs}</div>
            {children}
          </section>
        </Container>
      </Layout>
    </main>
  )
}
